import { parsePhoneNumberFromString } from 'libphonenumber-js'

export function deriveCountryCode(
  storedCountryCode: string | null | undefined,
  number: string | null | undefined,
): string | undefined {
  if (storedCountryCode) return storedCountryCode
  if (!number) return undefined
  try {
    return parsePhoneNumberFromString(number)?.country
  } catch {
    return undefined
  }
}
